import * as angular from "angular";
import {IController, ITimeoutService} from "angular";


export class PlanningSortMenuCtrl implements IController {

  onChange: Function;
  sortBy:any;
  showText?: boolean;
  sortByType:any;

  constructor(private $timeout: ITimeoutService) {
  }

  $onInit() {
  }

  onOpen($mdMenu, ev) {
    this.$timeout(0).then(() => {
      $mdMenu.open(ev);
    });
  }

  onSortByChange(sortBy) {
    this.onChange({sortBy: sortBy, sortByType: this.sortByType})
  }

  onSortByTypeChange(sortByType) {
    this.onChange({sortBy: this.sortBy, sortByType: sortByType});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningSortMenu', {
    bindings: {
      sortBy: '<',
      sortByType: '<',
      showText: '<?',
      onChange: '&',
    },
    template: require('./planning-sort-menu.html').default,
    controller: PlanningSortMenuCtrl
  });
